<template>
  <div class="page-con">
    <div class="list-box common-shadow clearfix">
      <iframe ref="mapFrame"
              :style="fullScreen ? 'width:100%;height:100vh;position: fixed;left: 0;top: 0;z-index: 9999;':'width:100%;height:100vh;'"
              frameborder=0 name="showHere" scrolling="no" :src="`${publicPath}carInfo/fwCar.html`"></iframe>
    </div>
  </div>
</template>
<script>
  import {hideLoading, showLoading} from "@/utils/util";

  import {apiGet} from "@/utils/api";

  export default {
    name: 'fwCar',
    data() {
      return {
        fullScreen: true,
        publicPath: process.env.BASE_URL,
      }
    },
    created() {
      let that = this;
      this.$nextTick(function () {
        window.addEventListener('message', (e) => {
          try {
            let data = JSON.parse(e.data)
            if (data.method) {
              that.receiveFrameData(data);
            }
            if (data.carNum) {
              this.setData(data.carNum);
            }
            if (data.logistics) {
              this.setLogistics(data);
            }
          } catch (e) {
            console.log(e)
          }
        })
      })
    },
    methods: {
      setData(carNum) {
        showLoading();
        let obj = {
          carName: carNum
        }
        let that = this;
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow
            iframeWin.postMessage(JSON.stringify(obj), '*')
            hideLoading();
          }, 500);
        });
      },
      setLogistics(data) {
        showLoading();
        let that = this;
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow
            iframeWin.postMessage(JSON.stringify(data), '*')
            hideLoading();
          }, 500);
        });
      },
      async receiveFrameData(data) {
        let mapFrame = this.$refs.mapFrame;
        if (undefined != mapFrame) {
          console.log("参数", data)
          let res = await apiGet("api/order/track/", data.method, data.params);
          let result = {
            code: res.status,
            data: res.data,
            message: res.message,
            method: data.method + "Call"
          }
          let iframeWin = mapFrame.contentWindow
          iframeWin.postMessage(JSON.stringify(result), '*')
        }
      }
    }
  }
</script>
<style>

</style>
